import ContactSection from "@/components/sections/ContactSection";
import useSEO, { BASE_URL, DEFAULT_OG_IMAGE } from "@/hooks/useSEO";

export default function Contacto() {
  useSEO({
    title: "Contacto · C.D. La Bombonera de Barcelona",
    description:
      "Escribinos al C.D. La Bombonera de Barcelona. Hacete socio, consultas de tienda, sponsors o prensa. Te respondemos en menos de 48h.",
    canonical: `${BASE_URL}/contacto`,
    image: DEFAULT_OG_IMAGE,
  });
  return (
    <main data-testid="contacto-page" className="pt-24">
      <ContactSection standalone />
    </main>
  );
}
